import React from 'react';
import {ROUTES} from "../../routes/Routes";
import NavBarWeb from "./web/NavBarWeb";

import "./NavBar.css";
import NavBarResponsive from "./responsive/NavBarResponsive";

export default function NavBar(props) {

    const selected = props.selected;
    const setSelected = props.setSelected;

    return (

        <React.Fragment>
            <div
                className={
                    "default-max-width default-align-center default-margin-top-medium " +
                    "default-text-align-center default-justify-center default-margin-auto"
                }
            >
                <div className={"navbar-display-web"}>
                    <NavBarWeb routes={ROUTES} selected={selected} setSelected={setSelected} />
                </div>
                <div className={"navbar-display-responsive"}>
                    <NavBarResponsive routes={ROUTES} selected={selected} setSelected={setSelected} />
                </div>
            </div>
        </React.Fragment>

    )

}